// Copyright © 2022 Kaleido, Inc.
//
// SPDX-License-Identifier: Apache-2.0
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//     http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

import { createContext } from 'react';
import { IEvent } from '../interfaces/api';
import { IEventHistoryItem } from '../interfaces/events';

export interface IEventContext {
  addLogToHistory: (event: IEvent) => void;
  logHistory: Map<string, IEventHistoryItem>;
  awaitedEventID: string | undefined;
  addAwaitedEventID: (apiRes: any) => void;
  refreshBalances: string;
  refreshAPIs: string;
}

export const EventContext = createContext({} as IEventContext);
